"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTableSections = void 0;
const Table_1 = __importDefault(require("./Table"));
const utils_1 = require("./utils");
Object.defineProperty(exports, "createTableSections", { enumerable: true, get: function () { return utils_1.createTableSections; } });
exports.default = Table_1.default;
